// extracted by mini-css-extract-plugin
export default {"box":"Header_box__V0FJ9","appBar":"Header_appBar__pvgwH","toolbar":"Header_toolbar__-iRa2"};